import React, { useEffect, useState } from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import deleteIcon from "~/assets/icons/delete.png";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import {EditIcon} from "~/Components/Icons/Icons";
import Layout from "~/Admin/Layout/Layout";
import Pagination from "react-js-pagination";
import AdminAddUser from "./AdminAddUser";
import AdminEditUser from "./AdminEditUser";

const AdminUserManagement = ({match, event, user, ...props}) => {

    const [response, setResponse] = useState({
        data: []
    });

    const loadData = (page = 1) => {
        adminHttp
            .get('/users?page=' + page)
            .then(res => setResponse(res.data));
    };

    const handleDelete = (id) => {
        adminHttp
            .delete('/users/' + id)
            .then(res => {
                loadData()
            });
    }

    useEffect(loadData, [event]);

    return (
        <Layout>
            <div className="admin-inventory">
                <div className="row">
                    <div className="col-8">
                        <h1>User Management</h1>
                    </div>
                    <div className="col-4 text-right">
                        <AdminAddUser onChange={loadData} className="btn btn-primary btn-sm" >+ New User</AdminAddUser>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card shadow-sm bg-white mt-3">
                            <div className="card-body">
                                <table className="table">

                                    <thead>
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Company</th>
                                        <th scope="col">Role</th>
                                        <th scope="col"></th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {response.data.map(u => (
                                        <tr key={u.id}>
                                            <th scope="col">{u.id}</th>
                                            <td scope="col">{u.full_name}</td>
                                            <td scope="col">{u.email}</td>
                                            <td scope="col">{u.company}</td>
                                            <td scope="col">{u.role.name}</td>
                                            <td scope="col">

                                                <AdminEditUser key={u.updated_at} id={u.id} onChange={loadData} className="cursor-pointer d-inline">
                                                    <EditIcon classes="d-inline mr-2" />
                                                </AdminEditUser>

                                                {user.id !== u.id && (
                                                    <ConfirmedLink className="cursor-pointer d-inline" onClick={() => handleDelete(u.id)}>
                                                        <img src={deleteIcon}/>
                                                    </ConfirmedLink>
                                                )}

                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {response.per_page < response.total && (
                                    <Pagination
                                        activePage={response.current_page}
                                        itemsCountPerPage={response.per_page}
                                        totalItemsCount={response.total}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={loadData}
                                    />
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </Layout>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
});

export default connect(mapStateToProps)(AdminUserManagement);
